import GuidingText from 'common/components/guidingText'

import { InputElement } from '../../interface'
import NumberInput from '../NumberInput'

import FormItem from './FormItem'
import { FormInstance } from './interfaces'

type Props = {
  field: InputElement
  form: FormInstance
  disabled?: boolean
  onChange: (value: string) => void
  className?: string
}

const AudienceSize: React.FC<Props> = ({
  field,
  form,
  disabled = false,
  className,
  onChange,
}) => {
  const { getFieldDecorator } = form

  return (
    <FormItem
      field={field}
      form={form}
      className={`updated-component${className ? ` ${className}` : ''}`}
    >
      <div>
        {getFieldDecorator(field.property_name, {
          rules: field.rules,
        })(
          <NumberInput
            data-cy="campaign-setup-list-size"
            data-testid="campaign-setup-list-size"
            id={field.field_id}
            style={{ width: 170 }}
            min={0}
            disabled={disabled}
            placeholder={field.placeholder}
            onChange={(value) => {
              onChange(
                value !== undefined && value !== null ? value.toString() : ''
              )
            }}
          />
        )}
        {field.tooltip && <GuidingText text={field.tooltip} />}
      </div>
    </FormItem>
  )
}

export default AudienceSize
